import { Backend } from '../Backend';
import { ICommitQuote3, IQuotePriceResponse3, IValidQuotePriceResponse3 } from '../models/AndromeTV.types';

export class QuoteApi {
  /**
   * Retrieve a list of valid quotes from the backend
   */
  static list(backend: Backend, catalogId?: string): Promise<IValidQuotePriceResponse3[]> {
    const url = backend.makeUrl('price/v3/quote', { catalogId: catalogId });
    return backend.getJson(url, backend.bearer) as Promise<IValidQuotePriceResponse3[]>;
  }

  /**
   * Remove a quote from the backend
   */
  static delete(backend: Backend, quoteId: string): Promise<Response> {
    const url = backend.makeUrl(`price/v3/quote/${encodeURIComponent(quoteId)}`);
    return backend.delete(url, backend.bearer) as Promise<Response>;
  }

  /**
   * Commit a quote
   */
  static commit(backend: Backend, quoteId: string, value: ICommitQuote3): Promise<IValidQuotePriceResponse3> {
    const url = backend.makeUrl(`price/v3/quote/${encodeURIComponent(quoteId)}/commit`);
    return backend.putJson(url, value, backend.bearer) as Promise<IValidQuotePriceResponse3>;
  }

  /**
   * Update a quote
   */
  static update(backend: Backend, quoteId: string, value: string): Promise<IQuotePriceResponse3> {
    const url = backend.makeUrl(`price/v3/quote/${encodeURIComponent(quoteId)}/update`);
    return backend.putJson(url, { code: value }, backend.bearer) as Promise<IQuotePriceResponse3>;
  }

  /**
   * Create a quote for a bundle
   */
  static createForBundle(backend: Backend, bundleId: string, deviceId?: string): Promise<IQuotePriceResponse3> {
    const url = backend.makeUrl(`price/v3/bundle/${encodeURIComponent(bundleId)}`);
    return backend.postJson(url, { deviceId: deviceId }, backend.bearer) as Promise<IQuotePriceResponse3>;
  }

  /**
   * Create a quote for a VOD
   * @param {Backend} backend
   * @param {string} vodId
   * @param {string} [deviceId]
   * @returns {Promise<IQuotePriceResponse3>}
   */
  static createForVod(backend: Backend, vodId: string, deviceId?: string): Promise<IQuotePriceResponse3> {
    const url = backend.makeUrl(`price/v3/vod/${encodeURIComponent(vodId)}`);
    return backend.postJson(url, { deviceId: deviceId }, backend.bearer) as Promise<IQuotePriceResponse3>;
  }
}
